import React from "react";
import Link from "gatsby-link";
import TitleAndMetaTags from "../components/TitleAndMetaTags";

import Socials from "../layouts/socials";
//
// Home page of portfolio site
//
export const IndexPage = ({ data }) => {
  // const homepage = data.wordpressPage
  const profileImage =
    "https://avatars1.githubusercontent.com/u/11691740?s=400&u=afdc25daf8ef2da5a544a15ee74ce275f649b4fe&v=4";
  // "https://media.licdn.com/mpr/mpr/shrinknp_400_400/AAMAAwDGAAwAAQAAAAAAAAoEAAAAJDA0MDM1NTMyLTc4NTAtNDI3ZS05NzE2LWZkNzQ1YWQzMTQ2ZA.jpg";
  // "https://avatars2.githubusercontent.com/u/11691740?s=400&u=ecc0f3a8d8f7c26cd8fd8ad840eb249c4f1fccee&v=4";
  // "https://scontent-sin6-1.xx.fbcdn.net/v/t31.0-8/13217611_10154542797444123_3236936950005546321_o.jpg?oh=dba792df2faf897da8ac69b3980562b6&oe=5AB904EE";
  // "https://media.licdn.com/mpr/mpr/shrinknp_400_400/AAMAAwDGAAwAAQAAAAAAAA4jAAAAJGUzMzY3YWNkLTVhODQtNGQ4MC05OGU3LTcyNzcxYmI0YWZiMQ.jpg";
  return (
    <div className="front-page">
      <TitleAndMetaTags title={"Aaron Ong - Full Stack Developer"} />
      <div className="card-wrap">
        <div className="image-wrap">
          <div className="mask">
            <div
              className="profile-image"
              style={{
                backgroundImage: `url(${profileImage})`,
                width: "213px",
                height: "213px",
                position: "relative",
                left: "27px",
                top: "-18px"
              }}
            >
              {" "}
            </div>
          </div>
        </div>
        <div className="content">
          <h2>Aaron Ong</h2>
          <h3>Full Stack Developer</h3>
          <p>
            Web Developer passionate about Software Design, and System
            Architecture. Also a Freelance Consultant, Basketball player and
            Liberal arts student.
          </p>
          <Socials />
        </div>
      </div>
    </div>
  );
};

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js